import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';


@Injectable()
export class RhynoApiProvider {
  Token:any = '';
  User:any = {};
  public UserAccount: Observable<any>;
  public _UserAccount: any;
  
  constructor(public http: Http, private afAuth: AngularFireAuth, afDb: AngularFireDatabase, affs: AngularFirestore) {
    console.log('Hello RhynoApiProvider Provider');

     this.afAuth.authState.subscribe(user => {
      if (!user) {
        this.Token = null;
        
        this.User = null;
        this.UserAccount = null;
        return;
      }
      this.User = user;
      this.UserAccount = affs.doc('useraccount/'+user.uid).valueChanges();
      this.getUserAccount();
      user.getIdToken(false).then(idToken =>  {

        console.log(idToken);
        this.Token = idToken;
      });
    });
  }

  getUserAccount(){
    this.UserAccount.subscribe(account => {
      this._UserAccount = account
    })
  }

  getUserToken(): Promise<string>{
    let that = this;
    return new Promise(function(resolve, reject){
      if (that.isLoggedIn()){
        that.User.getIdToken(false).then(newToken=>{
          that.Token = newToken;
          resolve(that.Token);
        }); //get 
      }else{
        resolve(null);
       // return null;
      }
    });
    
  }
  isLoggedIn(): boolean{
    //if (this.User && this.Token){
    if (this.User){
      return true;
    }else{
      return false;
    }
  }

  createLeistung(leistung):any{
    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var header = new Headers();
      header.append("Accept", 'application/json');
      header.append('Content-Type', 'application/json' );
      var options = new RequestOptions({ headers: header });

      console.log(leistung);
      var data = JSON.stringify(leistung);
      return this.http.post("https://api.rhyno.ch/api/leistung?token="+token, data, options);
    })
  }
  changeLeistung(leistung):any{
    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var header = new Headers();
      header.append("Accept", 'application/json');
      header.append('Content-Type', 'application/json' );
      var options = new RequestOptions({ headers: header });

      console.log(leistung);
      var data = JSON.stringify(leistung);
      return this.http.put("https://api.rhyno.ch/api/leistung/"+leistung.LEISTUNG_ID+"?token="+token, data, options);
    });
  }
  deleteLeistung(leistungId):any{
    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var header = new Headers();
      header.append("Accept", 'application/json');
      header.append('Content-Type', 'application/json' );

      return this.http.delete("https://api.rhyno.ch/api/leistung/"+leistungId+"?token="+token);
    });  
  }
	getLeistungsartikel(kunde){
    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
  		var response = this.http.get("https://api.rhyno.ch/api/leistungsartikel/"+kunde+"?token="+token).map(res => res.json());
        return response;
    });
	}

	getMitarbeiter(){
    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var response = this.http.get("https://api.rhyno.ch/api/mitarbeiter?token="+token).map(res => res.json());
      return response;
    });
  }

  getVersion(){
    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var response = this.http.get("https://api.rhyno.ch/api/version?token="+token).map(res => res.json());
      return response;
    });
  }

	getProjekt(filter){
    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var filterString='';
      if (filter.Kunde){
        filterString = "&Kunde="+filter.Kunde;
      }
      var response = this.http.get("https://api.rhyno.ch/api/projekt?"+filterString+"&token="+token).map(res => res.json());
      return response;
    });
  }


getProjektAll(){
  //Alle, für Project assignments (Admin)
    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var response = this.http.get("https://api.rhyno.ch/api/projektAll?&token="+token).map(res => res.json());
      return response;
    });
  }

  getProjectassignments(filter){
  //Alle, für Project assignments (Admin)
    console.log(filter)
    var filterString='';
      if (filter.Projekt){
        filterString = "&projekt="+filter.Projekt;
      }
    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var response = this.http.get("https://api.rhyno.ch/api/projektassignment?"+filterString+"&token="+token).map(res => res.json());
      return response;
    });
  }

  setProjectassignments(item){
  //Alle, für Project assignments (Admin)
    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var header = new Headers();
      header.append("Accept", 'application/json');
      header.append('Content-Type', 'application/json' );
      var options = new RequestOptions({ headers: header });

      console.log(item);
      var data = JSON.stringify(item);
      return this.http.post("https://api.rhyno.ch/api/projektassignment?token="+token, data, options);
    })
  }

  getProjektcontrolling(item){
  //Alle, für Project assignments (Admin)
    console.log('Projektcontrolling')
    console.log(item)
    var filterString='';
      if (item.Projekt){
        filterString = "&Projekt="+item.Projekt;
      }
    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var response = this.http.get("https://api.rhyno.ch/api/projektcontrolling?"+filterString+"&token="+token).map(res => res.json());
      return response;
    });
  }

	getLeistung(filter){

    console.log('Projektcontrolling')
    console.log(filter)
    var filterString='';
    if (filter){
      if (filter.Datum){
        filterString = "&Datum="+filter.Datum;
      }
      if (filter.Mitarbeiter){
        filterString = filterString+"&Mitarbeiter="+filter.Mitarbeiter;
      }
    }

    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var response = this.http.get("https://api.rhyno.ch/api/leistung?token="+token+filterString).map(res => res.json());
      return response;
    });
  }


  getPrice(artikel, kunde){
    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var response = this.http.get("https://api.rhyno.ch/api/artikel/"+artikel+"/preis/"+kunde+"?token="+token).map(res => res.json());
      return response;
    });
  }

  getInbox(){
    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var response = this.http.get("https://api.rhyno.ch/api/inbox?token="+token ).map(res => res.json());
      return response;
    });
  }

  deleteInboxItem(eventId){
    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var response = this.http.delete("https://api.rhyno.ch/api/inbox/"+eventId+"?token="+token);
      return response;
    });
  }

  getErfassungscontrolling(filter){
    console.log('getExpenseItems')
    console.log(filter)
    var filterString='';
    if (filter){
      if (filter.Datum){
        filterString = "&Datum="+filter.Datum;
      }
    }

    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var response = this.http.get("https://api.rhyno.ch/api/erfassungscontrolling?token="+token+filterString).map(res => res.json());
      return response;
    });
  }

  getExpenseItems(filter){
    console.log('getExpenseItems')
    console.log(filter)
    var filterString='';
    if (filter){
      if (filter.Datum){
        filterString = "&Datum="+filter.Datum;
      }
    }

  //Alle, für Project assignments (Admin)
    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var response = this.http.get("https://api.rhyno.ch/api/expenseItems?&token="+token+filterString).map(res => res.json());
      return response;
    });
  }
  getExpenseItem(item){
  //Alle, für Project assignments (Admin)
  console.log(item)
    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var response = this.http.get("https://api.rhyno.ch/api/expenseItem?&Belegnummer="+item.Belegnummer+"&Posnummer="+item.Posnummer+"&token="+token).map(res => res.json());
      return response;
    });
  }

  createExpenseItem(item){
    console.log('createExpenseItem')
    //Alle, für Project assignments (Admin)
    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var header = new Headers();
      header.append("Accept", 'application/json');
      header.append('Content-Type', 'application/json' );
      var options = new RequestOptions({ headers: header });

      console.log(item);
      var data = JSON.stringify(item);
      return this.http.post("https://api.rhyno.ch/api/expenseItem?token="+token, data, options);
    })
  }
  deleteExpenseItem(item){
    console.log('createExpenseItem')

    //Alle, für Project assignments (Admin)
    return Observable.fromPromise(this.getUserToken()).mergeMap(token => {
      var header = new Headers();
      header.append("Accept", 'application/json');
      header.append('Content-Type', 'application/json' );
      var options = new RequestOptions({ headers: header });

      return this.http.delete("https://api.rhyno.ch/api/expenseItem?token="+token+"&Belegnummer="+item.Belegnummer+"&Posnummer="+item.Posnummer, options);
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/rhyno-api/rhyno-api.ts